import _ from 'lodash';
import {
  useState,
  useEffect,
} from 'react';
import DailydeenService from "../../service_v2/dailydeen/dailydeen-service";

const themesListAddOrUpdate = () => {
  const [ responseData, setResponseData ] = useState({ });
  const [ updateData, setUpdateData ] = useState(null);
  const {
    items,
    onOperationComplete,
  } = updateData || {};

  const addUpdateItems = async () => {
    try {
      console.log(`DailyDeen add or update themes list times...`);
      setResponseData({
        isUpdating: true,
        isError: false,
      });

      console.log("updating items", items)
      const themesListItemsAddUpdateApiResp = await DailydeenService.updateDailyDeenThemesList({
        lang: "en",
        data: items
      });
      const responseData = themesListItemsAddUpdateApiResp;

      let errorMsg = null;
      let isError = false;

      console.log("updating complete", responseData)


      if(responseData.errors.length  == 0) {
        console.log('DailyDeen themes list add/update Success!!');
      } else {
        console.log('DailyDeen themes list add/update Failed!!');
        errorMsg = `Failed to add/update DailyDeen items.`;
        isError = true;
      }

      setResponseData({
        isUpdating: false,
        isError,
        errorMsg,
        data: responseData.payload,
      });

      if(onOperationComplete) {
        onOperationComplete({
          isError,
          errorMsg,
          data: responseData.payload,
        });
      }
    } catch (err) {
      console.log('Something went wrong while add/update DailyDeen themes list items. ', err);
      const errorMsg = `Error occurred while add/update DailyDeen themes list items.`;
      setResponseData({
        isUpdating: false,
        isError: true,
        errorMsg,
        data: null,
      });
      if(onOperationComplete) {
        onOperationComplete({
          isError: true,
          errorMsg,
          data: null,
        });
      }
    }
  };

  useEffect( () => {
    if(!_.isEmpty(updateData)) {
      addUpdateItems();
    }
  }, [ updateData ]);

  return [
    responseData,
    setUpdateData,
  ];
};

export default themesListAddOrUpdate;